import get from 'lodash/get';

import { productId, productSubcategory } from '~/lib/tealium/lookups';

const getPageName = (offerId, folio) => {
  let productId_lookup = productId[offerId];
  let productSubcategory_lookup = productSubcategory[offerId];
  const pageNamePrefix = 'ib:offers:credit cards';
  const pageUrlPrefix = '/offers/credit-cards';
  const page_subcategory = 'credit cards';
  return {
    cardDetails: {
      error_type: '',
      funnel_step: '1',
      funnel_step_name: 'offer',
      page_category: 'offers',
      page_name: pageNamePrefix,
      page_subcategory,
      page_type: 'application',
      page_url: pageUrlPrefix,
      product_category: 'credit cards',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
    },
    processing: {
      error_type: '',
      funnel_step: '2',
      funnel_step_name: 'processing',
      page_category: 'offers',
      page_name: `${pageNamePrefix}:processing`,
      page_subcategory,
      page_type: 'other',
      page_url: `${pageUrlPrefix}/processing`,
      product_category: 'credit cards',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
    },
    cardSuccess: {
      application_id: folio,
      application_decision: 'completed',
      error_type: '',
      funnel_step: '3',
      funnel_step_name: 'confirmation',
      page_category: 'offers',
      page_name: `${pageNamePrefix}:confirmation`,
      page_subcategory,
      page_type: 'application',
      page_url: `${pageUrlPrefix}/confirmation`,
      product_category: 'credit cards',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
    },
    errorPage: {
      error_type: 'application',
      funnel_step: '',
      funnel_step_name: '',
      page_category: 'offers',
      page_name: `${pageNamePrefix}:technical error`,
      page_subcategory,
      page_type: 'error',
      page_url: `${pageUrlPrefix}/technical-error`,
      product_category: '',
      product_subcategory: '',
      product_id: '',
    },
    timeout: {
      error_type: 'application',
      funnel_step: '',
      funnel_step_name: 'timeout',
      page_category: 'offers',
      page_name: `${pageNamePrefix}:timeout`,
      page_subcategory,
      page_type: 'error',
      page_url: `${pageUrlPrefix}/timeout`,
      product_category: '',
      product_subcategory: '',
      product_id: '',
    },
  };
};

const getPageData = (currentPage, offerId, folio) => {
  return {
    ...get(getPageName(offerId, folio), currentPage),
  };
};

export default getPageData;
